export const api = {
  syncDahuaPersonnel: '/vas/personnel/syncDahuaPersonnel.json', //同步人员
  syncDahuaDept: '/vas/personnel/syncDahuaDept.json', //同步部门
  getGroup: '/bms/turnstilegate/queryTurnstilegateRightGroupList.json', //获取权限组
  queryGroup: '/vas/personnel/queryPersonnelTurnstileRightList.json', //获取个人权限组
  updateGroup: '/vas/personnel/updatePersonnelTurnstileRightGroup.json', //更新个人权限组
  queryPersonList: '/vas/personnel/queryPersonList.json', //获取列表
  syncPersonnel: '/vas/personnel/syncPersonnel.json', //员工同步
  getVisitorTypeList: '/vas/personnel/queryVisitorTypeList.json', //获取页面左侧访客类型列表
  addVisitorType: '/vas/personnel/addVisitorType.json', //新增访客类型
  updateVisitorType: '/vas/personnel/updateVisitorType.json', //修改访客类型
  deleteVisitorType: '/vas/personnel/deleteVisitorType.json', //删除访客类型
  updateVisitorVisitorType: '/vas/personnel/updateVisitorVisitorType.json', //挪入挪出
  departmentTree: '/vas/department/queryDepartmentTree.json', //部门树
  queryDepartmentDetail: '/vas/department/queryDepartmentDetail.json', //部门树负责人接口
  addPersonnel: '/vas/personnel/addPersonnel.json', //新增访客信息
  updatePersonnel: '/vas/personnel/updatePersonnel.json', //修改访客信息
  deletePersonnel: '/vas/personnel/deletePersonnel.json', //删除访客信息
  queryDeptTree: 'vas/dept/queryDeptTree.json',
  queryDept: 'vas/dept/queryDeptList.json',
  queryPersonType: '/bms/personAuthorization/queryPersonnelMark.json' //查询员工类型
}
